import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { MyThunkDispatch, RootState } from 'store';

import { fetchRestCountryList } from 'actions/i18n';
import useEmergencyMessage from 'hooks/useEmergencyMessage';
import Login from 'screens/components/Login';
import { verifyInviteExists, resendInvite } from 'services/loginService';
import { resendTwoFactor } from 'services/otpService';
import { verifyLinkedRappiUser, VerifyLinkedRappiUserParameters } from 'services/registrationService';

const LoginContainer = () => {
  const dispatch: MyThunkDispatch = useDispatch();
  const emergencyMessage = useEmergencyMessage();

  const { restCountries, loadingRestCountries } = useSelector((state: RootState) => state.i18n);

  const fetchCountryCodes = () => dispatch(fetchRestCountryList());
  const verifyInvite = (email: string) => verifyInviteExists(email);
  const verifyLinkedUser = (data: VerifyLinkedRappiUserParameters) => verifyLinkedRappiUser(data);
  const resend = (email: string) => resendInvite(email);
  const resendTwoFactorAuth = (key: string) => resendTwoFactor(key);

  useEffect(() => {
    emergencyMessage.reset();
  }, [emergencyMessage]);

  return (
    <Login
      fetchCountryCodes={fetchCountryCodes}
      restCountries={restCountries}
      loadingRestCountries={loadingRestCountries}
      verifyInviteExists={verifyInvite}
      verifyLinkedUser={verifyLinkedUser}
      resendInvite={resend}
      resendTwoFactor={resendTwoFactorAuth}
    />
  );
};

export default LoginContainer;
